import JudgingYearEditView from '@/views/admin/judging/JudgingYearEditView.vue';

export const adminJudgeRoutes = [
  {
    path: '/admin/judging/:yearId/:tabName?',
    name: 'AdminJudgeYearEdit',
    component: JudgingYearEditView,
    meta: { guest: false },
  },
];
